import React from 'react';
import useTitle from 'react-use/lib/useTitle';
import { LandingModule } from 'app/modules/web-shop/sub-modules/landing-module/layout';

export default function Landing() {
  useTitle('AIDA - Results-driven open data solutions');

  return <LandingModule />;
}
